import { useShouldShowFeatureFlag } from 'common/features/FeatureFlag/hooks/useFeatureFlag';
import React from 'react';

const ProfileCardV2 = React.lazy(() => import('stacks/ProfileCardV2/views/ProfileCardV2'));
const ProfileCardV3 = React.lazy(() => import('stacks/ProfileCardV2/views/ProfileCardV3'));

const ArtistLinks: React.FC = () => {
  const [showKaleidoCardV3] = useShouldShowFeatureFlag('kaleidoCardV3');

  if (showKaleidoCardV3) {
    return <ProfileCardV3 />;
  }
  return <ProfileCardV2 />;
};

export default ArtistLinks;
